import { pushGenericEventData } from './generic-event';

const baseEventParams = {
  eventCategory: 'Flight Grid',
  eventAction: 'holidays banner',
  eventValue: null
};

export const fireHolidayBannerVisualization = (
  bannerTitle: string,
  pricePP: string | null,
  date: string | null,
  duration: string | null,
  isGeneric: boolean
) => {
  const eventLabel = isGeneric ? 'generic holiday banner impression' : 'holiday banner impression';
  return pushGenericEventData(
    { ...baseEventParams, eventLabel: eventLabel, eventType: 'nonInteraction' },
    { genericValue1: bannerTitle.toLowerCase(), genericValue2: pricePP, genericValue3: date, genericValue4: duration }
  );
};

export const fireHolidayBannerInteraction = (
  destinationUrl: string,
  bannerTitle: string,
  pricePP: string | null,
  date: string | null,
  duration: string | null,
  isGeneric: boolean
) => {
  const eventLabel = isGeneric ? 'generic holiday banner clicks' : 'holiday banner clicks';
  return pushGenericEventData(
    { ...baseEventParams, eventLabel: eventLabel, eventType: 'interaction' },
    {
      destinationUrl: destinationUrl,
      genericValue1: bannerTitle.toLowerCase(),
      genericValue2: pricePP,
      genericValue3: date,
      genericValue4: duration
    }
  );
};
